import React from 'react'
import heroimg from './Heroimg.jpg'
import img1 from './img1.jpg'
import img2 from '../images/img2.jpg'
import img3 from '../images/img3.jpg'
import img4 from '../images/img4.jpg'
import img5 from '../images/img5.jpg'
import img6 from '../images/img6.jpg'
import img7 from '../images/img7.jpg'

export default function Hero() {
  return (
    <>
      <div className="relative w-full">
        <img src={heroimg} className='opacity-25 md:h-[620px] h-[400px] w-full object-cover' alt="Hero" />
        <div className="absolute inset-0  flex flex-col md:flex-row items-center justify-center md:justify-between px-10">
          <div className='flex flex-col items-start md:ml-20'>
            <h4 className='font-extrabold md:text-5xl text-xl mb-5 '>NEW ERA OF LEARNING.....</h4>
            <h4 className='font-semibold md:text-3xl text-xl mb-3'>Learn and Enjoy</h4>
          
            <p>
              Online Paathshala is the one Paathshala
              For all the Learners.......<br></br>
              where they can get quality education at affordable price.... 
            </p>
            <button className='bg-cuscolor-light font-bold text-white p-3 rounded-3xl mt-5 hover:bg-cuscolor hover:text-white transition ease-in-out hover:-translate-y-1 duration-300 delay-150 hover:scale-105'>
              Apply Now
            </button>
          </div>
          <div className='grid grid-cols-3 gap-2 mt-9 md:mt-0 md:grid-cols-3 md:grid-rows-3 md:gap-x-2 md:gap-y-4 '>
            <div className='col-start-1 row-start-1'>
              <img src={img1} alt='img1' className='h-20 w-20 md:h-40 md:w-40 md:rounded-md rounded-full' />
            </div>
            <div className='col-start-2 row-start-1'>
              <img src={img2} alt='img2' className='h-20 w-20 md:h-40 md:w-40 md:rounded-md rounded-full' />
            </div>
            <div className='col-start-3 row-start-1 md:col-start-3 md:row-start-3'>
              <img src={img3} alt='img3' className='h-20 w-20 md:h-40 md:w-40 md:rounded-md rounded-full' />
            </div>
            {/* Hidden images on mobile */}
            <div className='col-start-1 row-start-2 hidden md:block'>
              <img src={img4} alt='img4' className='md:h-40 md:w-40 rounded-md' />
            </div>
            <div className='col-start-2 row-start-2 hidden md:block'>
              <img src={img5} alt='img5' className='md:h-40 md:w-40 rounded-md' />
            </div>
            <div className='col-start-3 row-start-2 hidden md:block'>
              <img src={img6} alt='img6' className='md:h-40 md:w-40 rounded-md' />
            </div>
            <div className='col-start-2 row-start-3 hidden md:block'>
              <img src={img7} alt='img7' className='md:h-40 md:w-40 rounded-md' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
